import { useTranslation } from 'react-i18next'
import { Badge } from './Badge'

interface PreFilledBadgeProps {
  className?: string
}

export function PreFilledBadge({ className = '' }: PreFilledBadgeProps) {
  const { t } = useTranslation('common')
  // EP-108: use the kit Badge (Thai-descender-safe) instead of a raw .badge —
  // the kit itself must follow its own never-raw-.badge rule (found while
  // authoring the LLM catalog; the audit sweep had excluded the kit dir).
  return (
    <Badge variant="ghost" size="sm" className={className}>
      {t('labels.pre_filled')}
    </Badge>
  )
}
